import { Button, Col, Row } from "antd";
import React, { memo } from "react";
import { DownloadOutlined } from "@ant-design/icons";

const TmsExcelButton = ({ loading, handleExcelExport, top, label }) => {
  return (
    <Col>
      {!top && (
        <Button loading={loading} type="primary" onClick={handleExcelExport}>
          <DownloadOutlined /> {label ?? "Excel"}
        </Button>
      )}
      {top && (
        <>
          <Row
            justify="start"
            style={{ marginBottom: "5px", color: "transparent" }}
          >
            .
          </Row>
          <Row justify="start">
            <Button
              loading={loading}
              type="primary"
              onClick={handleExcelExport}
            >
              <DownloadOutlined /> {label ?? "Excel"}
            </Button>
          </Row>
        </>
      )}
    </Col>
  );
};
export default memo(TmsExcelButton);
